export const CHIP_GROUP_COLORS = {
  cyan:    '#22d3ee',  // your existing accent
  violet:  '#a78bfa',
  amber:   '#fbbf24',
  rose:    '#fb7185',
  blue:    '#60a5fa',
  fuchsia: '#e879f9',
  lime:    '#a3e635',
  emerald: '#34d399',
  orange:  '#fb923c',
  slate:   '#94a3b8',
};